import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import { PupAvatar } from '@web/components';
import { useReporter } from '../../reporter';
import { MEALPREP_SELECTION_SUBPATH } from '../routing';
import { changePlanClicked } from './events';
import {
  AvatarContainer,
  IconButton,
  IconLink,
  IconLinkText,
  Modify,
  StyledSummaryCard,
  SummaryInfo,
} from './styles.js';

export const SummaryCard = ({
  avatarBgColor,
  breeds,
  children,
  onDeletePet,
  petId,
}) => {
  const [isDeletingPet, setIsDeletingPet] = useState(false);
  const reporter = useReporter();
  const deletePetAndDisable = async () => {
    setIsDeletingPet(true);
    await onDeletePet();
    setIsDeletingPet(false);
  };
  return (
    <StyledSummaryCard>
      <AvatarContainer>
        <PupAvatar
          backgroundColor={avatarBgColor}
          breeds={breeds}
          color="secondary.carrot"
          fullBleed
          variant="circle"
        />
      </AvatarContainer>

      <SummaryInfo>
        {children}

        <Modify>
          {onDeletePet && (
            <IconButton
              onClick={deletePetAndDisable}
              disabled={isDeletingPet}
              type="button"
            >
              Remove
            </IconButton>
          )}
          <IconLink
            href={`/onboarding/${MEALPREP_SELECTION_SUBPATH}/?pet_id=${petId}`}
            onClick={() => reporter.tag(changePlanClicked())}
          >
            <Icon
              iconName="pencil"
              size="16px"
              color="hero.blueberry"
              alt=""
              id="change_plan"
            />
            <IconLinkText>Edit</IconLinkText>
          </IconLink>
        </Modify>
      </SummaryInfo>
    </StyledSummaryCard>
  );
};
SummaryCard.displayName = 'SummaryCard';
SummaryCard.propTypes = {
  avatarBgColor: PropTypes.string.isRequired,
  breeds: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node,
  onDeletePet: PropTypes.func,
  petId: PropTypes.string.isRequired,
};
